import { useContext, Context } from "react";

export function useContextWithGuard<T>(context: Context<T | undefined>, name: string): T {
    const value = useContext(context);
    if (value === undefined) {
        throw new Error(`use${name} must be used within a ${name}Provider`);
    }
    return value;
}